<template>
  <div
    v-if="data"
    class="membership-page"
  >
    <div class="membership-header">
      <button
        type="button"
        class="nav-btn"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <div class="page-title">
        {{ $t('vipPage.title') }}
      </div>
      <button
        type="button"
        class="nav-btn"
        @click="$router.push('/grap')"
      >
        <!--   <van-icon
          name="bars"
          size="22"
        /> -->
      </button>
    </div>

    <main class="membership-content">
      <section class="membership-summary">
        <div class="membership-summary-copy">
          <span>{{ $t('vipPage.currentLevel') }}</span>
          <strong>{{ currentLevelName }}</strong>
        </div>
        <span class="membership-summary-mark">{{ $t('vipPage.vipMark') }}</span>
      </section>

      <div class="membership-section-heading">
        <span>{{ $t('vipPage.levelTitle') }}</span>
        <i />
      </div>

      <section class="vip-list">
        <button
          v-for="item in levelCards"
          :key="item.key"
          type="button"
          class="vip-card"
          :class="[item.cardClass, { 'is-current': item.isCurrent }]"
        >
          <div class="vip-logo-box">
            <img
              v-if="item.image"
              :src="item.image"
              alt=""
              class="vip-logo-img"
              @error="hideBrokenImage"
            >
            <span class="vip-logo-text">{{ $t('vipPage.vipMark') }}</span>
          </div>

          <div class="vip-card-copy">
            <div class="vip-card-name">
              {{ item.name }}
            </div>
            <div class="vip-card-desc">
              <p
                v-for="line in item.lines"
                :key="line"
              >
                {{ line }}
              </p>
            </div>
          </div>

          <div
            v-if="item.isCurrent"
            class="current-badge"
          >
            {{ $t('vipPage.currentLevel') }}
          </div>
        </button>

        <!--      <div class="vip-card date-card">
          <div class="vip-logo-box">
            <span class="vip-logo-text">{{ $t('vipPage.vipMark') }}</span>
          </div>
          <div class="vip-card-copy">
            <div class="vip-card-name">
              {{ $t('vipPage.dateCard') }}
            </div>
            <div class="vip-card-desc state-desc">
              {{ $t('vipPage.stateNotActivated') }}
            </div>
          </div>
        </div> -->
      </section>
    </main>
  </div>
</template>

<script>
import Vue from 'vue';
import { Icon } from 'vant';
import Fetch from '../../utils/fetch';

Vue.use(Icon);

export default {
  name: 'Vip',
  data() {
    return {
      data: null,
      vips: [],
      colorClasses: [
        'card-steel',
        'card-orange',
        'card-indigo',
        'card-blue'
      ]
    };
  },
  computed: {
    currentLevelName() {
      const currentCard = this.levelCards.find((item) => item.isCurrent);
      return currentCard ? currentCard.name : this.$t('vipPage.normalLevel');
    },
    levelCards() {
      const cards = [
        // {
        //   key: 'normal',
        //   name: this.$t('vipPage.normalLevel'),
        //   lines: [this.$t('vipPage.freeBenefits')],
        //   cardClass: 'card-normal',
        //   image: '',
        //   isCurrent: this.isNormalCurrent()
        // }
      ];

      (this.vips || []).forEach((item, index) => {
        cards.push({
          key: item.id || `${item.name}-${index}`,
          name: this.getVipName(item, index),
          lines: this.getVipLines(item, index),
          cardClass: this.colorClasses[index % this.colorClasses.length],
          image: this.getVipImage(item),
          isCurrent: this.isCurrentLevel(item)
        });
      });

      return cards;
    }
  },
  created() {
    this.$parent.footer('item', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/user/basicinfo').then((r) => {
        this.data = r.data || {};
        this.vips = this.data.vips || [];
      });
    },
    goUpgrade(item) {
      if (!item || item.key === 'normal') {
        return;
      }
      this.$router.push('/invest');
    },
    getVipName(item, index) {
      if (item && item.name) {
        const name = String(item.name).trim();
        const match = name.match(/^vip\s*(\d+)?$/i);
        if (match) {
          return `VIP${match[1] || this.getVipNo(item, index)}`;
        }
        return name;
      }
      return `VIP${this.getVipNo(item, index)}`;
    },
    getVipLines(item, index) {
      const value = this.formatMoney(item && item.value);
      const rate = this.formatRate(item && item.rate);
      const orderCount = this.getOrderCount(item, index);

      return [
        `${this.$t('vipPage.requiredInvestment')} ${this.moneyMark()}${value}`,
        `${this.$t('vipPage.commission')} ${rate}% | ${orderCount} ${this.$t('vipPage.order')}`
      ];
    },
    getVipImage(item) {
      if (item && item.imgh) {
        return item.imgh;
      }
      if (item && item.img) {
        return item.img;
      }
      return '';
    },
    getVipNo(item, index) {
      const no = Number(item && item.no);
      if (no > 0) {
        return no;
      }
      return index + 1;
    },
    getOrderCount(item, index) {
      const orderCount = Number(item && item.onum );
      return orderCount;
    },
    isCurrentLevel(item) {
      const current = this.data && this.data.vip;
      if (!item || !current) {
        return false;
      }

      if (current.id && item.id && Number(current.id) === Number(item.id)) {
        return true;
      }

      if (current.name && item.name && current.name === item.name) {
        return true;
      }

      if (this.data.vip_name && item.name && this.data.vip_name === item.name) {
        return true;
      }

      if (current.no && item.no && Number(current.no) === Number(item.no)) {
        return true;
      }

      return false;
    },
    isNormalCurrent() {
      if (!this.data) {
        return false;
      }

      if (!this.data.vip && !this.data.vip_name) {
        return true;
      }

      return Number(this.data.baoku_money || 0) <= 0 && !this.isAnyVipCurrent();
    },
    isAnyVipCurrent() {
      return (this.vips || []).some((item) => this.isCurrentLevel(item));
    },
    moneyMark() {
      if (typeof this.utils_moneyMark === 'function') {
        return this.utils_moneyMark();
      }
      return localStorage.getItem('moneyMark') || '$';
    },
    formatMoney(value) {
      const numberValue = Number(value);
      if (!Number.isFinite(numberValue)) {
        return '0.00';
      }
      return numberValue.toFixed(2);
    },
    formatRate(value) {
      const numberValue = Number(value);
      if (!Number.isFinite(numberValue)) {
        return '0.00';
      }
      return numberValue.toFixed(2);
    },
    hideBrokenImage(event) {
      event.target.style.display = 'none';
    }
  }
};
</script>

<style lang="less" scoped>
.membership-page {
  min-height: 100vh;
  background: #f1f8f7;
  color: #123d42;
  padding-bottom: 80px;
  box-sizing: border-box;
}

.membership-header {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  border-bottom: 1px solid #075e67;
  background: #063942;
  box-sizing: border-box;
}

.nav-btn {
  width: 30px;
  height: 30px;
  border: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  color: #e3fbf8;
  font-size: 18px;
  line-height: 30px;
  box-sizing: border-box;
}

.nav-btn:empty {
  pointer-events: auto;
  opacity: 0;
}

.page-title {
  max-width: 72%;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.membership-content {
  padding: 16px 16px 0;
}

.level-title {
  margin: 0 0 20px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
}

.vip-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.vip-card {
  width: 100%;
  min-height: 118px;
  position: relative;
  display: grid;
  grid-template-columns: 78px minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  padding: 18px 16px;
  border: 1px solid #075e67;
  border-radius: 14px;
  overflow: hidden;
  text-align: left;
  color: #f4fffe;
  background-color: #063942;
  background-image: url('../images/ban5/vip-bg.png');
  background-repeat: no-repeat;
  background-position: center right 18px;
  background-size: 170px auto;
  box-shadow: 0 10px 20px rgba(10, 73, 79, 0.16);
  box-sizing: border-box;
}

.vip-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(3, 57, 66, 0.96) 0%, rgba(7, 90, 98, 0.82) 60%, rgba(12, 129, 136, 0.32) 100%);
  pointer-events: none;
}

.vip-card::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: var(--vip-accent, #71d2cc);
  opacity: 0.78;
}

.vip-logo-box {
  width: 72px;
  height: 72px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid #a8d5d0;
  background: #e8f5f3;
  color: #063942;
  box-shadow: 0 6px 14px rgba(0, 38, 44, 0.18);
  z-index: 1;
}

.vip-logo-text {
  position: absolute;
  top: 25px;
  left: 0;
  right: 0;
  color: #08646d;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
}

.vip-logo-img {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  object-fit: cover;
}

.vip-card-copy {
  min-width: 0;
  position: relative;
  z-index: 1;
}

.vip-card-name {
  margin-bottom: 8px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.vip-card-desc {
  color: #d4f0ed;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
}

.vip-card-desc p {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.vip-card-desc p + p {
  font-size: 12px;
}

.state-desc {
  color: #c8ece8;
  font-size: 14px;
  font-style: italic;
}

.current-badge {
  min-width: 88px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  border: 1px solid rgba(191, 243, 237, 0.72);
  border-radius: 14px;
  color: #fff;
  background: rgba(255, 255, 255, 0.14);
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  white-space: nowrap;
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
}

.card-normal {
  --vip-accent: #aeb3bb;
}

.card-steel {
  --vip-accent: #8f775f;
}

.card-blue {
  --vip-accent: #4d9bd8;
}

.card-orange {
  --vip-accent: #e89b55;
}

.card-indigo {
  --vip-accent: #8d83d8;
}

.date-card {
  --vip-accent: #3fa384;
}

@media (max-width: 360px) {
  .membership-content {
    padding-right: 12px;
    padding-left: 12px;
  }

  .vip-card {
    grid-template-columns: 66px minmax(0, 1fr);
    gap: 12px;
    padding-right: 14px;
    padding-left: 14px;
  }

  .vip-logo-box {
    width: 62px;
    height: 62px;
  }

  .current-badge {
    min-width: 78px;
    height: 26px;
    font-size: 12px;
  }
}

/* Membership levels use the same teal hierarchy as the account dashboard. */
.membership-page { background: linear-gradient(180deg, #f3f9f8, #ebf5f3); }
.membership-header { height: 50px; border-bottom-color: #c7e0dd; background: rgba(255, 255, 255, .97); box-shadow: 0 4px 14px rgba(10, 73, 79, .07); }
.nav-btn { background: #e8f5f3; color: #075963; }
.page-title { color: #073f47; }
.membership-content { padding: 14px 16px 24px; }
.membership-summary { min-height: 104px; position: relative; display: flex; align-items: center; justify-content: space-between; overflow: hidden; padding: 18px 22px; border: 1px solid #075e67; border-radius: 18px; background: linear-gradient(135deg, #063942, #0c8188); box-shadow: 0 14px 26px rgba(5, 71, 77, .18); box-sizing: border-box; }
.membership-summary::before, .membership-summary::after { position: absolute; border: 1px solid rgba(255, 255, 255, .12); border-radius: 50%; content: ''; pointer-events: none; }
.membership-summary::before { width: 132px; height: 132px; top: -70px; right: -26px; }
.membership-summary::after { width: 90px; height: 90px; right: 56px; bottom: -62px; }
.membership-summary-copy { position: relative; z-index: 1; display: flex; flex-direction: column; }
.membership-summary-copy span { color: #c8ece8; font-size: 13px; font-weight: 600; line-height: 20px; }
.membership-summary-copy strong { margin-top: 3px; color: #fff; font-size: 24px; font-weight: 700; line-height: 30px; }
.membership-summary-mark { position: relative; z-index: 1; color: rgba(255, 255, 255, .18); font-size: 42px; font-weight: 800; line-height: 1; letter-spacing: -2px; }
.membership-section-heading { display: flex; align-items: center; gap: 10px; margin: 20px 2px 12px; color: #074b53; font-size: 14px; font-weight: 700; line-height: 20px; }
.membership-section-heading i { height: 1px; flex: 1; background: #c7e0dd; }
.vip-list { position: relative; gap: 10px; padding-left: 10px; }
.vip-list::before { position: absolute; top: 18px; bottom: 18px; left: 2px; width: 1px; background: #c7e0dd; content: ''; }
.vip-card { min-height: 102px; grid-template-columns: 66px minmax(0, 1fr); gap: 13px; padding: 14px 16px; border-color: #c9e1de; border-radius: 16px; background: #fff; background-image: none; box-shadow: 0 8px 18px rgba(12, 75, 79, .08); color: #123d42; }
.vip-card::before { inset: auto; top: -44px; right: -30px; width: 120px; height: 120px; border-radius: 50%; background: rgba(232, 245, 243, .9); }
.vip-card::after { width: 3px; border-radius: 3px; opacity: 1; }
.vip-logo-box { width: 64px; height: 64px; border-color: #c7e0dd; border-radius: 14px; box-shadow: none; }
.vip-logo-img { padding: 4px; object-fit: contain; box-sizing: border-box; }
.vip-card-name { margin-bottom: 5px; padding-right: 96px; color: #074b53; font-size: 17px; }
.vip-card-desc { color: #60797c; font-size: 12px; line-height: 19px; }
.vip-card-desc p + p { color: #08646d; font-size: 12px; }
.current-badge { min-width: 82px; height: 25px; right: 14px; top: 14px; padding: 0 8px; border-color: #a8d5d0; border-radius: 13px; background: #e8f5f3; color: #075963; font-size: 11px; }
.card-normal { --vip-accent: #91a7a5; }
.card-steel { --vip-accent: #799995; }
.card-blue { --vip-accent: #54a6ae; }
.card-orange { --vip-accent: #d7a453; }
.card-indigo { --vip-accent: #8496c9; }
.date-card { --vip-accent: #5b9f89; }

@media (max-width: 360px) {
  .membership-content { padding-right: 12px; padding-left: 12px; }
  .vip-card { grid-template-columns: 60px minmax(0, 1fr); gap: 10px; padding-right: 12px; padding-left: 12px; }
  .vip-logo-box { width: 58px; height: 58px; }
  .vip-card-name { padding-right: 82px; font-size: 16px; }
  .current-badge { min-width: 72px; right: 10px; }
}
</style>
